import { Injectable, Injector } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';

import { environment } from '../../../environments/environment';

import { Logger } from './logger.service';
import { ActivatedRoute, Router } from '@angular/router';

/**
 * Settings for Log Interceptor
 */
  // If set to false only specified routes are logged
const logAllRoutes = true;
const routesWhiteList = [  // Only active if logAllRoutes = false | only routes on whitelist are logged

];

const routesBlackList = [  // Only active if logAllRoutes = true | all routes but routes on blacklist are logged

];

const redirectBlackList = [  // disables redirect to LogIn-Page after HTTP Error 401 for specific URLs
'/imprint', '/tos', '/privacy', '/copyright',
];

// Settings for successful requests
const requestDetails = {
  showLog: true,        // Turn on/off logs for successful requests
  method:  true,        // Display method (GET, POST, ...)
  status:  true,        // Display status (200, 401, ...)
  time:    true,        // Display elapsed time
  body:    true,        // Display body of request if existent
};

// Settings for failed requests
const errorDetails = {
  showLog: true,        // Turn on/off logs for failed requests
  method:  true,        // Display method (GET, POST, ...)
  status:  true,        // Display status (200, 401, ...)
  time:    true,        // Display elapsed time
};

/**
 * Interceptor that adds the authentication header to request
 */
@Injectable()
export class LogInterceptor implements HttpInterceptor {
  private router: Router;
  private route: ActivatedRoute;

  /**
   * Constructor
   */
  constructor(private injector: Injector) {}

  /**
   * Intercepts the request and adds the authentication header
   * @param {HttpRequest<any>} req Request
   * @param {HttpHandler}      next HttpHandler
   * @returns {Observable<HttpEvent<any>>} Observable<HttpEvent<any>>
   */
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const started = Date.now();

    this.router = this.injector.get(Router);
    this.route = this.injector.get(ActivatedRoute);

    return next.handle(req)
      .do((event: HttpEvent<any>) => {

        if (event instanceof HttpResponse) {

          const elapsed = Date.now() - started;

          // Only log if not production build and logging of successful requests is activated
          if (!environment.production && requestDetails.showLog) {

            // Removes the backend url prefix of request url
            const shortendUrl = req.url.substr(environment.backendUrl.length, req.url.length);

            // Log only if logging for all routes is activated or the current route is on the 'whitelist'
            if ((logAllRoutes && routesBlackList.indexOf(shortendUrl) === -1) || routesWhiteList.indexOf(shortendUrl) !== -1) {
              let output = '┌──── SUCCESSFUL REQUEST ─────\n';

              output += '│ url:    ' + req.url + '\n';

              if (requestDetails.method) {
                output += '│ method: ' + req.method + '\n';
              }

              if (requestDetails.status) {
                output += '│ status: ' + event.status + '\n';
              }

              if (requestDetails.time) {
                output += '│ time:   ' + elapsed + 'ms\n';
              }

              const body = event.body.data || req.body || null;  // Body is different if GET or POST method is used
              if (requestDetails.body && body) {
                output += '│ body:\n';

                // Display all keys and values
                for (const key in body) {
                  if (body.hasOwnProperty(key)) {
                    output += '│   ' + key + ': ' + JSON.stringify(body[key]) + '\n';
                  }
                }
              }

              output += '└─────────────────────────────';

              Logger.log(output);
            }
          }
        }
      }, (err: any) => {

        if (err instanceof HttpErrorResponse) {
          if (err.status === 401) {

            // Scip Redirect to Login-Page for specific URLs
            if (redirectBlackList.indexOf(this.router.url) === -1) {
              this.router.navigate(['login']).then(
                  () => {
                    Logger.log(
                        '\n┌─────── LOGIN TIMEOUT ───────┐\n' +
                        '│ JWT is no longer valid!     │\n' +
                        '│ -> Navigated to Login       │\n' +
                        '└─────────────────────────────┘',
                    );
                  },
              );
            } else {
              Logger.log(
                  '\n┌─────── LOGIN TIMEOUT ───────┐\n' +
                  '│ JWT is no longer valid!     │\n' +
                  '└─────────────────────────────┘',
              );
            }

          } else if (err.status === 403 || err.status === 404 || err.status === 408) {
            // Only log if not production build and logging of failed requests is activated
            if (!environment.production && errorDetails.showLog) {

              const elapsed = Date.now() - started;

              let output = '\n┌────── FAILED REQUEST ───────\n';

              output += '│ url:    ' + req.url + '\n';

              if (errorDetails.method) {
                output += '│ method: ' + req.method + '\n';
              }

              if (errorDetails.status) {
                output += '│ status: ' + err.status + ' (' + err.statusText + ')' + '\n';
              }

              if (errorDetails.time) {
                output += '│ time:   ' + elapsed + 'ms\n';
              }

              output += '└─────────────────────────────';

              Logger.error(output);
            }
          }
        }
      });
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/shared/services/log.interceptor.ts